import React, { useState } from "react";
import { Button, Modal, ModalBody } from "react-bootstrap";
import './index.css';
import { Container, Row } from 'react-bootstrap';
// import useFormModal from "../Utils/useFormModal";
import htmlParser from "html-react-parser"; // Import the parser
import SignUpForm from "../SignupForm/SignupForm";
const HowItWorks = ({ data }) => {


    const [showForm, setShowForm] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showFailModal, setShowFailModal] = useState(false);
    const [validated, setValidated] = useState(false);
    let prevScrollPos = window.scrollY;
    const handleFailClose = () => {
        setShowFailModal(false);
        setValidated(false);
    };
    const handleSuccessClose = () => {
        setShowSuccessModal(false);
        setValidated(false);
    };

    const handleShowForm = () => {
        setShowForm(true);
    };
    const handleCloseForm = () => {
        setShowForm(false);
    };

    const handleContactUsClick = () => {
        setShowForm(true);
    };

    const { title, description, applynow } = data?.howItWorks;

    return (
        <div className="howdivtesd">
        <section id="howitworks">
            <Container>
                <Row>
                    <div className="how-it-works-section">
                        <h1>{htmlParser(title)}</h1>
                        <p>{htmlParser(description)}</p>
                        <button className="apply-now" onClick={handleContactUsClick}>{applynow}</button>
                    </div>

                </Row>
            </Container>
            <Modal backdrop="static" centered show={showForm} onHide={handleCloseForm} size="lg">
                <Modal.Header closeButton onClick={handleCloseForm}>
                    <Modal.Title>Please fill the information below to continue</Modal.Title>
                </Modal.Header>
                <ModalBody className='form-modal'>

                    <SignUpForm closeForm={handleCloseForm} requestFromModal={true} setShowSuccessModal={setShowSuccessModal} setShowFailModal={setShowFailModal} />
                </ModalBody>
            </Modal>
            <Modal
                size="lg"
                centered
                show={showSuccessModal}
                onHide={handleSuccessClose}
                backdrop="static"
            >
                <Modal.Header closeButton />
                <Modal.Body className="text-center">
                    <p className="thanktext m-4">Thank you for your interest. One of our representatives will contact you shortly. We look forward to serving you!</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleSuccessClose}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                size="lg"
                centered
                show={showFailModal}
                onHide={handleFailClose}
                backdrop="static"
            >
                <Modal.Header closeButton />
                <Modal.Body>
                    <p className="thanktext">
                        Due to technical difficulties your request could not be processed.
                        Please contact us at&nbsp;
                        <a href={"mailto:inquiry@swmc.com"} className="form-link">
                            inquiry@swmc.com
                        </a>
                        .
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleFailClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </section>
        </div>
    );
};

export default HowItWorks;
